import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const BurningIssue = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.burningIssue.title')}
      contentType="burningIssue"
      description={t('page.burningIssue.desc')}
      outputLabel={t('page.burningIssue.output')}
      showDurationSelector
      programMode
    />
  );
};
